import { each, intersection, map, orderBy, toNumber } from 'lodash';
import { COMBOS } from '../constant';
import { CalActivityEnum, DiscountTypeEnum, OffTypeEnum, ProductRelationEnum, StatusEnum, UsePromoCodeStatusEnum, } from '../enum';
import { findActivityProduct, toFixed } from '../lib/utils';
/**
 * 计算现在配送费的订单金额
 * @param opt
 * @returns
 */
function calNowOrderPrice(opt) {
    var _a;
    const { product, activity, itemMap } = opt;
    let { nowOrderPrice } = opt;
    let joinActitity = false;
    let relationKey = 'productRelation';
    if (COMBOS.includes(product.type)) {
        relationKey = 'productComboRelation';
    }
    if (activity[relationKey] !== ProductRelationEnum.All) {
        const findProduct = findActivityProduct(activity.productMap, product);
        if (findProduct && activity[relationKey] === ProductRelationEnum.Included) {
            joinActitity = true;
        }
        else if (!findProduct && activity[relationKey] === ProductRelationEnum.Excluded) {
            joinActitity = true;
        }
    }
    else {
        joinActitity = true;
    }
    if (joinActitity) {
        const key = product.pk || '';
        nowOrderPrice +=
            (activity.isIncludeModifier ? product.productAndModifierPrice : product.price) * (product.cnt || 1);
        if (itemMap[key]) {
            nowOrderPrice = toFixed(nowOrderPrice - (((_a = itemMap[key].apportion) === null || _a === void 0 ? void 0 : _a.off) || 0) - itemMap[key].itemAllOff, 4);
        }
    }
    return nowOrderPrice;
}
export default function calExpressFeeDiscount(opt) {
    const { productMap, itemMap, expressProducts, isSelectCoupon, selectCouponIds, expressCoupons, memberCouponMap, couponsConfigMap, enablePromoCodeActivity, } = opt;
    let { usePromoCodeStatus } = opt;
    let { expressFeeDiscountcountActivitys } = opt;
    const orderByExpressProducts = orderBy(expressProducts, ['price'], ['desc']);
    const maxPriceExpressProduct = orderByExpressProducts[0];
    const expressFee = (maxPriceExpressProduct === null || maxPriceExpressProduct === void 0 ? void 0 : maxPriceExpressProduct.price) || 0;
    if (isSelectCoupon) {
        const expressCouponIds = map(expressCoupons, 'memberCouponId');
        const intersectionExpressCouponIds = intersection(selectCouponIds, expressCouponIds);
        if (intersectionExpressCouponIds.length > 0 && expressCoupons.length > 0) {
            // 使用优惠券
            expressFeeDiscountcountActivitys = [
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                memberCouponMap[intersectionExpressCouponIds[0]],
            ];
        }
    }
    else {
        if (expressCoupons.length > 0) {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            expressFeeDiscountcountActivitys.push(...expressCoupons);
        }
    }
    if (expressCoupons.length > 0) {
        const disableExpressMemberCouponIds = new Set();
        each(expressCoupons, (expressCoupon) => {
            var _a, _b;
            if (disableExpressMemberCouponIds.has(expressCoupon.memberCouponId)) {
                memberCouponMap[expressCoupon.memberCouponId].isSelect = false;
                memberCouponMap[expressCoupon.memberCouponId].canUse = false;
                memberCouponMap[expressCoupon.memberCouponId].status = StatusEnum.Disable;
            }
            let nowOrderPrice = 0;
            each(productMap, (product) => {
                var _a;
                let joinCoupon = false;
                let relationKey = 'productRelation';
                if (COMBOS.includes(product.type)) {
                    relationKey = 'productComboRelation';
                }
                if (expressCoupon[relationKey] !== ProductRelationEnum.All) {
                    const findProduct = findActivityProduct(couponsConfigMap[expressCoupon.couponId].productMap, product);
                    if (findProduct && expressCoupon[relationKey] === ProductRelationEnum.Included) {
                        joinCoupon = true;
                    }
                    else if (!findProduct && expressCoupon[relationKey] === ProductRelationEnum.Excluded) {
                        joinCoupon = true;
                    }
                }
                else {
                    joinCoupon = true;
                }
                if (joinCoupon) {
                    const key = product.pk || '';
                    nowOrderPrice +=
                        (expressCoupon.isIncludeModifier ? product.productAndModifierPrice : product.price) * (product.cnt || 1);
                    if (itemMap[key]) {
                        nowOrderPrice = toFixed(nowOrderPrice - (((_a = itemMap[key].apportion) === null || _a === void 0 ? void 0 : _a.off) || 0) - itemMap[key].itemAllOff, 4);
                    }
                }
            });
            let couponOff = 0;
            each((_b = (_a = couponsConfigMap[expressCoupon.couponId]) === null || _a === void 0 ? void 0 : _a.extra) === null || _b === void 0 ? void 0 : _b.ladderDiscount, (ladderDiscount) => {
                if (nowOrderPrice >= toNumber(ladderDiscount.orderFee)) {
                    if (ladderDiscount.discountType === DiscountTypeEnum.DiscountFee) {
                        couponOff = toNumber(ladderDiscount.discountValue);
                    }
                    else if (ladderDiscount.discountType === DiscountTypeEnum.DiscountRate) {
                        couponOff = toFixed(expressFee * (1 - ladderDiscount.discountValue));
                    }
                    else if (ladderDiscount.discountType === DiscountTypeEnum.SpecialOffer) {
                        couponOff = toFixed(expressFee - toNumber(ladderDiscount.discountValue));
                    }
                    if (couponOff > expressFee) {
                        couponOff = expressFee;
                    }
                    if (couponOff) {
                        return;
                    }
                }
            });
            if (couponOff <= 0) {
                memberCouponMap[expressCoupon.memberCouponId].isSelect = false;
                memberCouponMap[expressCoupon.memberCouponId].canUse = false;
                memberCouponMap[expressCoupon.memberCouponId].status = StatusEnum.Disable;
                disableExpressMemberCouponIds.add(expressCoupon.memberCouponId);
            }
        });
    }
    let nowExpressFeeOff = 0;
    let useActivity;
    if (expressFeeDiscountcountActivitys && expressFeeDiscountcountActivitys.length > 0) {
        each(expressFeeDiscountcountActivitys, (activity) => {
            var _a, _b, _c;
            if (activity.couponId) {
                if (activity.status === StatusEnum.Disable) {
                    return true;
                }
                activity.productMap = couponsConfigMap[activity.couponId].productMap;
                activity.extra = couponsConfigMap[activity.couponId].extra;
            }
            let nowOrderPrice = 0;
            each(productMap, (product) => {
                var _a;
                nowOrderPrice = calNowOrderPrice({ product, activity, itemMap, nowOrderPrice });
                if ((product === null || product === void 0 ? void 0 : product.swapBuyProducts) && ((_a = product.swapBuyProducts) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                    each(product.swapBuyProducts, (swapBuyProduct) => {
                        nowOrderPrice = calNowOrderPrice({ product: swapBuyProduct, activity, itemMap, nowOrderPrice });
                    });
                }
            });
            // 满足条件
            let off = 0;
            let ladderDiscounts = [
                {
                    orderFee: activity.orderFee,
                    discountType: activity.discountType,
                    discountValue: activity.discountValue,
                    enable: true,
                    index: 1,
                },
            ];
            if (((_a = activity.extra) === null || _a === void 0 ? void 0 : _a.ladderDiscount) && ((_b = activity.extra) === null || _b === void 0 ? void 0 : _b.ladderDiscount.length) > 0) {
                ladderDiscounts = (_c = activity.extra) === null || _c === void 0 ? void 0 : _c.ladderDiscount;
            }
            each(ladderDiscounts, (ladderDiscount) => {
                if (nowOrderPrice >= toNumber(ladderDiscount.orderFee)) {
                    if (ladderDiscount.discountType === DiscountTypeEnum.DiscountFee) {
                        off = toNumber(ladderDiscount.discountValue);
                    }
                    else if (ladderDiscount.discountType === DiscountTypeEnum.DiscountRate) {
                        off = toFixed(expressFee * (1 - ladderDiscount.discountValue));
                    }
                    else if (ladderDiscount.discountType === DiscountTypeEnum.SpecialOffer) {
                        off = toFixed(expressFee - toNumber(ladderDiscount.discountValue));
                    }
                    if (off > expressFee) {
                        off = expressFee;
                    }
                    if (nowExpressFeeOff < off) {
                        activity.orderFee = toNumber(ladderDiscount.orderFee);
                        activity.discountValue = toNumber(ladderDiscount.discountValue);
                        activity.discountType = ladderDiscount.discountType;
                        nowExpressFeeOff = off;
                        useActivity = activity;
                    }
                }
            });
        });
        if (nowExpressFeeOff > 0 && maxPriceExpressProduct) {
            if (useActivity.activityId && useActivity.promoCode) {
                if (usePromoCodeStatus === UsePromoCodeStatusEnum.Ineffective) {
                    usePromoCodeStatus = UsePromoCodeStatusEnum.Effective;
                }
                enablePromoCodeActivity.push(useActivity.activityId);
            }
            if (useActivity.memberCouponId) {
                each(expressCoupons, (expressCoupon) => {
                    if (expressCoupon.memberCouponId !== useActivity.memberCouponId) {
                        memberCouponMap[useActivity.memberCouponId].isSelect = false;
                        memberCouponMap[useActivity.memberCouponId].canUse = false;
                        memberCouponMap[useActivity.memberCouponId].status = StatusEnum.Mutex;
                    }
                });
                memberCouponMap[useActivity.memberCouponId].isSelect = true;
                memberCouponMap[useActivity.memberCouponId].canUse = true;
                memberCouponMap[useActivity.memberCouponId].status = StatusEnum.Enable;
            }
        }
    }
    if (useActivity === null || useActivity === void 0 ? void 0 : useActivity.discountType) {
        let maxDiscountFee = Infinity;
        if (useActivity.discountType === DiscountTypeEnum.DiscountFee) {
            maxDiscountFee = useActivity.discountValue;
        }
        each(orderByExpressProducts, (expressProduct) => {
            let remainOff = 0;
            if (useActivity.discountType === DiscountTypeEnum.DiscountFee) {
                remainOff = toFixed(toNumber(useActivity.discountValue));
            }
            else if (useActivity.discountType === DiscountTypeEnum.DiscountRate) {
                remainOff = toFixed(expressProduct.price * (1 - useActivity.discountValue));
            }
            else if (useActivity.discountType === DiscountTypeEnum.SpecialOffer) {
                remainOff = toFixed(expressProduct.price);
            }
            if (remainOff < 0) {
                remainOff = 0;
            }
            if (remainOff > 0) {
                if (remainOff > expressProduct.productAndModifierPrice) {
                    remainOff = expressProduct.productAndModifierPrice;
                }
                if (maxDiscountFee < remainOff) {
                    remainOff = maxDiscountFee;
                }
                maxDiscountFee -= remainOff;
                if (maxDiscountFee >= 0) {
                    const pk = expressProduct.pk || 'express';
                    itemMap[pk] = {
                        items: [
                            Object.assign(Object.assign({}, expressProduct), { off: remainOff, offId: (useActivity === null || useActivity === void 0 ? void 0 : useActivity.activityId) || (useActivity === null || useActivity === void 0 ? void 0 : useActivity.memberCouponId), offType: (useActivity === null || useActivity === void 0 ? void 0 : useActivity.couponId)
                                    ? OffTypeEnum.Coupon
                                    : useActivity.promoCode
                                        ? OffTypeEnum.PromoCode
                                        : OffTypeEnum.Activity, offTip: (useActivity === null || useActivity === void 0 ? void 0 : useActivity.activityName) || (useActivity === null || useActivity === void 0 ? void 0 : useActivity.couponName), calActivityType: CalActivityEnum.Express }),
                        ],
                        itemAllOff: remainOff,
                    };
                }
            }
        });
    }
    return { enablePromoCodeActivity, usePromoCodeStatus };
}
//# sourceMappingURL=calExpressFeeDiscount.js.map